import React from 'react';
import './row.scss';

export interface RowItemProps {
    children: any;
    isColumn?: boolean;
    wrap?: boolean;
}

const RowItem = ({children, isColumn, wrap}: RowItemProps) => {
    return (
        <div className={`row ${isColumn ? 'row__column' : ''} ${wrap ? 'row__wrap' : ''}`}>
            {children}
        </div>
    )
}

export default RowItem;
